import { Component, OnInit } from '@angular/core';
import { FormEntryComponentClass, FormComponentLookup } from '@ptl/forms';
import { ReducerUtilityService, StateStructure } from '@ptl/state';
import { Validators, UntypedFormControl } from '@angular/forms';
import { ZipCountyStateStructure } from 'src/app/angular-elements/shared/interfaces/zipCountyStateStructure.interface';
import { County } from '@ptl/global-components';
import { NgRedux } from '@ptl/angular-redux-store';
import { saveZipCounty } from '../../../../demographics/zip-county-modal/reducers/zipCounty.reducer';
//comment

@FormComponentLookup('zip-county-inputs')
@Component({
    selector: 'app-zip-county-inputs',
    templateUrl: './entry-zip-county-inputs.component.html',
    styleUrls: ['./entry-zip-county-inputs.component.scss'],
    standalone: false
})

export class EntryZipCountyInputsComponent extends FormEntryComponentClass implements OnInit {

  saveableCounty: County;
  saveableZipCode: string;

  preloadedValues = {
    zipCode: '',
    county: ''
  };

  constructor(
    protected ngRedux: NgRedux<StateStructure>,
    protected reducerUtilityService: ReducerUtilityService) {
    super();
  }

  ngOnInit(): void {
    const zipCountyState: ZipCountyStateStructure = this.reducerUtilityService.getComponentStates().ZipCounty;
    
    // add a county control to this form to save it in the payload
    this.form.addControl('county', new UntypedFormControl(null, Validators.required));

    // WY and MN use a default county for loading plans and such before the user ever enters a zip code.
    // This keeps it from showing up in the county field on first load
    if (zipCountyState.county) {
      this.saveableZipCode = zipCountyState.zipCode;
      this.saveableCounty = zipCountyState.county?.county !== 'default' ? zipCountyState.county : null;

      this.preloadedValues = {
        zipCode: this.saveableZipCode,
        county: this.saveableCounty?.county
      }
    }
  }

  zipCountyChanged(value: { county: County; zipCode: string; }) {
    // the ptl-zip component uses a disconnected form, so we have to update our forms-as-json form here when a response is received
    this.form.controls.zipCode.setValue(value.zipCode);
    this.form.controls.county.setValue(value.county);

    this.ngRedux.dispatch(saveZipCounty(value.zipCode, value.county));
  }
}

